import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { useErrorHandler } from '../utils/errorHandler';
import { ROLES } from '../utils/roles';
import { 
  FaUser, 
  FaLock, 
  FaSignInAlt,
  FaExclamationTriangle
} from 'react-icons/fa';
import './auth.css';
import Footer from './Footer';

const AuthLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { handleError } = useErrorHandler();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validation basique
    if (!email || !password) {
      setError('Veuillez remplir tous les champs');
      setLoading(false);
      return;
    }

    try {
      // Connexion avec Firebase Authentication
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Vérifier le rôle de l'utilisateur dans Firestore
      const userDoc = await getDoc(doc(db, 'identifications', user.uid));

      if (userDoc.exists()) {
        const userRole = userDoc.data().role;

        // Redirection en fonction du rôle avec constantes
        switch (userRole) {
          case ROLES.ADMIN:
            navigate('/admin-dashboard');
            break;
          case ROLES.SERVER:
            navigate('/server-interface');
            break;
          case ROLES.COOK:
            navigate('/cook-interface');
            break;
          case ROLES.BAR:
            navigate('/bar-interface');
            break;
          default:
            setError('Votre rôle ne permet pas d\'accéder à cette application.');
            break;
        }
      } else {
        setError('Utilisateur non trouvé dans la base de données.');
      }
    } catch (err) {
      const errorInfo = handleError(err, 'AuthLogin');
      setError(errorInfo.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Header */}
        <div className="login-header">
          <h1>Connexion Admin</h1>
          <p>Accédez à votre espace d'administration</p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="error-message">
            <FaExclamationTriangle className="error-icon" />
            <span>{error}</span>
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="email">
              <FaUser className="input-icon" />
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Entrez votre email"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <FaLock className="input-icon" />
              Mot de passe
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Entrez votre mot de passe"
              className="form-input"
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? (
              'Connexion en cours...'
            ) : (
              <>
                <FaSignInAlt />
                Se connecter
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="login-footer">
          <p>Développé par <span className="brand-name">SkanEat</span></p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AuthLogin;
